export const LINKING_FEATURES_CARD_OPTIONS = { allowDatasource: true };
